import { Pipe, PipeTransform } from "@angular/core";
import lodash from "lodash";

@Pipe({
  name: "timeLimiter"
})


/*
* TimeLimiterPipe will remove times from the Times array that are in the exceptionTimes array if it is after 4pm mst
* the exceptionTimes list and the times list are using the TimeListEnum to get its data
*/
export class TimeLimiterPipe implements PipeTransform {
  transform(times: string[], exceptionTimes: string[]): unknown {
    const currentTimeInUtah = new Date().toLocaleString('en-US', { timeZone: 'America/Denver' });
    return new Date(currentTimeInUtah).getHours() > 15 ? lodash.difference(times, exceptionTimes): times;
  }

}
